import React, { useEffect, type FC } from 'react';

import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { LoadablePaint } from '@confluence/loadable';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';

type CommentTypes = {
	showGeneralComment?: boolean;
	pageWidthType?: string;
	showLabels: boolean;
	hasReactions: boolean;
	editorIsUserOffline?: boolean;
};

const ObjectCommentContainerLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectCommentContainer" */ './ObjectCommentContainer.tsx'
			)
		).ObjectCommentContainer,
});

export const ObjectCommentWrapper: FC<CommentTypes> = ({
	showGeneralComment,
	pageWidthType,
	showLabels,
	hasReactions,
	editorIsUserOffline,
}) => {
	const { setShowGeneralComments } = useCommentsPanelActions();

	useEffect(() => {
		setShowGeneralComments(showGeneralComment);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
	}, []);

	const content = (
		<ObjectCommentContainerLoader
			pageWidthType={pageWidthType}
			showLabels={showLabels}
			hasReactions={hasReactions}
			editorIsUserOffline={editorIsUserOffline}
		/>
	);

	if (expValEquals('reduce_queries_in_default_suspense', 'isEnabled', true)) {
		return (
			<SuspenseWithDataFetcher dataFetcherName="object-comments">{content}</SuspenseWithDataFetcher>
		);
	}

	return content;
};
